import React, { Fragment, useState } from "react";
import { useSnackbar } from "notistack";
import parse from "html-react-parser";
import {
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  IconButton,
} from "@material-ui/core";
import {
  Cancel,
  Save,
  Edit,
  AddCircle,
  RemoveCircle,
  HourglassEmpty,
} from "@material-ui/icons";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { getContactUsInfo, postContactUsInfo } from "../../services";
import { Editor } from "../../components";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootRadio: {
      marginTop: ".5rem",
    },
    title: {
      fontWeight: 600,
    },
    input: {
      marginBottom: "1rem",
    },
    iconCircle: {
      padding: 0,

      "&:hover": {
        backgroundColor: "transparent",
      },
    },
  })
);

const FormInfoHubungiKami = ({ data, setData, onCancel }: any) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [dataState, setDataState] = useState(data);
  const [loadingButtonState, setLoadingButtonState] = useState(false);
  const {
    companyName,
    address,
    latitude,
    longitude,
    email,
    tlp,
    tlpMaps,
    fb,
    ig,
    tw,
    yt,
    desc_id,
    desc_en,
  } = dataState;

  const handleChange = (event: any, i: any = null) => {
    if (i || i === 0) {
      const currentPhone = dataState[event.target.name];
      currentPhone[i] = event.target.value;
      setDataState({ ...dataState, [event.target.name]: currentPhone });
      return;
    }
    setDataState({ ...dataState, [event.target.name]: event.target.value });
  };

  const handleAddPhone = (name: any) => {
    const currentPhone = dataState[name];
    currentPhone.push("");
    setDataState({
      ...dataState,
      [name]: currentPhone,
    });
  };

  const handleRemovePhone = (index: any, name: any) => {
    const currentPhone = dataState[name];
    currentPhone.splice(index, 1);
    setDataState({
      ...dataState,
      [name]: currentPhone,
    });
  };

  const handleAddContactUsInfo = async (e: any) => {
    e.preventDefault();

    try {
      setLoadingButtonState(true);
      const res = await postContactUsInfo(dataState);
      setLoadingButtonState(false);
      if (res.status === "error") {
        enqueueSnackbar(res.message, {
          variant: "error",
        });
        return;
      }
      enqueueSnackbar(`Berhasil mengedit data Lainnya`, {
        variant: "success",
      });
      setData(res.data);
      onCancel();
    } catch (err: any) {
      setLoadingButtonState(false);
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  return (
    <div style={{ padding: "0 1rem" }}>
      <Typography color="primary" variant="h5" style={{ marginBottom: "2rem" }}>
        Edit Data Lainnya
      </Typography>
      <form onSubmit={handleAddContactUsInfo}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={10}>
            <TextField
              onChange={handleChange}
              value={companyName}
              name="companyName"
              label="Nama"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={10}>
            <TextField
              onChange={handleChange}
              value={email}
              name="email"
              label="Email"
              variant="outlined"
              type="email"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              style={{ marginLeft: 8, fontWeight: 400, fontSize: 14 }}
              color="textSecondary"
              gutterBottom
            >
              Alamat
            </Typography>
            <Editor
              content={address}
              onChange={(content: any) =>
                setDataState({ ...dataState, address: content })
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              onChange={handleChange}
              value={latitude}
              name="latitude"
              label="Latitude"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              onChange={handleChange}
              value={longitude}
              name="longitude"
              label="Longitude"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              onChange={handleChange}
              value={desc_id}
              name="desc_id"
              label="Deskripsi ID"
              variant="outlined"
              rows={6}
              multiline
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              onChange={handleChange}
              value={desc_en}
              name="desc_en"
              label="Deskripsi EN"
              variant="outlined"
              rows={6}
              multiline
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              onChange={handleChange}
              value={fb}
              name="fb"
              label="Facebook"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              onChange={handleChange}
              value={ig}
              name="ig"
              label="Instagram"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              onChange={handleChange}
              value={yt}
              name="yt"
              label="Youtube"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              onChange={handleChange}
              value={tw}
              name="tw"
              label="Twitter"
              variant="outlined"
              fullWidth
              required
            />
          </Grid>
          <Grid
            item
            style={{
              display: "flex",
              flexDirection: "column",
              alignSelf: "flex-start",
              gap: 16,
            }}
          >
            {tlp.map((r: string, i: number) => (
              <div key={i} style={{ display: "flex", gap: 8 }}>
                <TextField
                  style={{ width: 200 }}
                  onChange={(e) => handleChange(e, i)}
                  value={r}
                  name="tlp"
                  label="Telepon di Peta"
                  variant="outlined"
                  fullWidth
                  required
                />
                <IconButton
                  className={classes.iconCircle}
                  onClick={() => handleRemovePhone(i, "tlp")}
                >
                  <RemoveCircle />
                </IconButton>
                {i === tlp.length - 1 && (
                  <IconButton
                    color="primary"
                    className={classes.iconCircle}
                    onClick={() => handleAddPhone("tlp")}
                  >
                    <AddCircle />
                  </IconButton>
                )}
              </div>
            ))}
          </Grid>
          <Grid
            item
            style={{
              display: "flex",
              flexDirection: "column",
              alignSelf: "flex-start",
              gap: 16,
            }}
          >
            {tlpMaps.map((r: string, i: number) => (
              <div key={i} style={{ display: "flex", gap: 8 }}>
                <TextField
                  style={{ width: 200 }}
                  onChange={(e) => handleChange(e, i)}
                  value={r}
                  name="tlpMaps"
                  label="Telepon di Peta"
                  variant="outlined"
                  fullWidth
                  required
                />
                <IconButton
                  className={classes.iconCircle}
                  onClick={() => handleRemovePhone(i, "tlpMaps")}
                >
                  <RemoveCircle />
                </IconButton>
                {i === tlpMaps.length - 1 && (
                  <IconButton
                    color="primary"
                    className={classes.iconCircle}
                    onClick={() => handleAddPhone("tlpMaps")}
                  >
                    <AddCircle />
                  </IconButton>
                )}
              </div>
            ))}
          </Grid>
          <Grid
            item
            container
            justify="flex-end"
            xs={12}
            style={{ marginTop: "2rem" }}
          >
            <Button
              style={{ marginRight: "1rem" }}
              variant="outlined"
              color="primary"
              size="large"
              startIcon={<Cancel />}
              type="submit"
              onClick={onCancel}
              disabled={loadingButtonState}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="large"
              startIcon={loadingButtonState ? <HourglassEmpty /> : <Save />}
              type="submit"
              disabled={loadingButtonState}
            >
              {loadingButtonState ? "Loading" : "Save"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

const InfoHubungiKami = () => {
  const classes = useStyles();
  const [editDataState, setEditDataState] = useState(false);
  const [contactUs, setContactUs] = useState({
    companyName: "",
    address: "",
    latitude: "",
    longitude: "",
    email: "",
    tlp: [],
    tlpMaps: [],
    fb: "",
    ig: "",
    tw: "",
    yt: "",
    desc_id: "",
    desc_en: "",
  });

  const fetchContectUsInfo = async () => {
    try {
      const res = await getContactUsInfo();
      setContactUs(res.data);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    fetchContectUsInfo();
  }, []);

  const {
    companyName,
    address,
    latitude,
    longitude,
    email,
    tlp,
    tlpMaps,
    fb,
    ig,
    tw,
    yt,
    desc_id,
    desc_en,
  } = contactUs;

  return (
    <Card>
      <CardContent>
        {editDataState ? (
          <FormInfoHubungiKami
            data={contactUs}
            onCancel={() => setEditDataState(false)}
            setData={(data: any) => setContactUs(data)}
          />
        ) : (
          <>
            <Typography
              color="primary"
              variant="h5"
              style={{ marginBottom: "2rem" }}
            >
              Data Lainnya
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={2}>
                <Typography className={classes.title}>Nama</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {companyName}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Alamat</Typography>
              </Grid>
              <Grid item xs={9}>
                {parse(address)}
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Latitude</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {latitude}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Longitude</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {longitude}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Email</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {email}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Telepon</Typography>
              </Grid>
              <Grid item xs={9}>
                {tlp.map((r: string, i: number) => (
                  <Typography key={i}>: {r}</Typography>
                ))}
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>
                  Telepon Di Peta
                </Typography>
              </Grid>
              <Grid item xs={9}>
                {tlpMaps?.map((r: string, i: number) => (
                  <Typography key={i}>: {r}</Typography>
                ))}
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Deskripsi ID</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {desc_id}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Deskripsi EN</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {desc_en}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Facebook</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {fb}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Instagram</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {ig}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Youtube</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {yt}</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.title}>Twitter</Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>: {tw}</Typography>
              </Grid>
              <Grid item container justify="flex-end" xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<Edit />}
                  type="submit"
                  onClick={() => setEditDataState(true)}
                >
                  Edit
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </CardContent>
    </Card>
  );
};

const HubungiKami = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <InfoHubungiKami />
      </Grid>
      {/* <Grid item xs={12} md={7}>
        <MaterialTable
          columns={[
            { title: "Fullname", field: "fullname" },
            { title: "Email", field: "email" },
            { title: "Subjek", field: "subjek" },
            { title: "Message", field: "message" },
            {
              title: "Created",
              field: "created_at",
              align: "right",
              render: (rowData) =>
                moment(rowData.created_at).format("YYYY-MM-DD HH:mm"),
            },
          ]}
          title={
            <Typography
              variant="h6"
              color="primary"
              style={{ fontWeight: 600 }}
            >
              List Data Hubungi Kami
            </Typography>
          }
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 25, 50],
          }}
          data={(query: any) =>
            new Promise((resolve) => {
              const { pageSize, page, search } = query;
              getContactUs(pageSize, page + 1, search).then((result) => {
                resolve({
                  data: result.data.rows,
                  page: Number(result.data.page - 1),
                  totalCount: Number(result.data.total),
                });
              });
            })
          }
        />
      </Grid> */}
    </Grid>
  );
};

export default HubungiKami;
